import { ComponentType, lazy } from 'react';

export const CHUNK_RELOAD_COOLDOWN_KEY = 'companio_chunk_reloaded_at';
export const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

export function isChunkLoadError(err: unknown): boolean {
  const msg = String((err as { message?: string } | null)?.message ?? err ?? '');
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('module script') ||
    msg.includes('MIME type') ||
    msg.includes("expected a JavaScript-or-Wasm module script")
  );
}

export function triggerChunkReload(): boolean {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_COOLDOWN_KEY) ?? 0);
  if (Date.now() - last < CHUNK_RELOAD_COOLDOWN_MS) return false;
  sessionStorage.setItem(CHUNK_RELOAD_COOLDOWN_KEY, String(Date.now()));

  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now().toString());
  window.location.replace(url.toString());
  return true;
}

export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      if (!isChunkLoadError(err)) throw err;
      if (!triggerChunkReload()) throw err;
      return new Promise<{ default: T }>(() => {});
    }
  });
}
